<template>
    <h2>상장정보</h2>
    <table>
        <tbody>
            <tr>
                <th>설립일</th>
                <td>1986. 5. 9</td>
            </tr>
            <tr>
                <th>상장일</th>
                <td>1998. 1. 20</td>
            </tr>
            <tr>
                <th>자본금</th>
                <td>194억 6백만원</td>
            </tr>
            <tr>
                <th>상장주식총수</th>
                <td>37,444,271</td>
            </tr>
            <tr>
                <th>결산일</th>
                <td>12월 31일</td>
            </tr>
        </tbody>
    </table>
</template>

<script></script>

<style lang="scss" scoped>
h2 {
    flex: 1 0 0;
    color: #111;
    font-size: 38px;
    font-weight: 700;

    @media screen and (max-width: 768px) {
        font-size: 24px;
    }
}

table {
    flex: 2 0 0;
    border-top: 2px solid #333;
    border-collapse: collapse;

    tr {
        border-bottom: 1px solid #e5e5e5;
        display: flex;

        th,
        td {
            padding: 40px 0;
        }

        th {
            flex: 0 0 220px;
            font-weight: 700;
            font-size: 20px;
            color: #111;
            text-align-last: left;
            padding-left: 40px;

            @media screen and (max-width: 768px) {
                flex: 0 0 160px;
                font-size: 18px;
                padding-left: 20px;
            }
        }

        td {
            color: #333;
            font-size: 18px;

            @media screen and (max-width: 768px) {
                font-size: 16px;
            }
        }
    }
}
</style>
